import sfaasTemp from './sfaas_temp';

export default {
	...sfaasTemp
};